import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = ({ onSubscribeClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <span className="text-2xl md:text-3xl font-bold text-primary-600">
              Artinent.com
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link
              to="/contact"
              className="text-neutral-700 hover:text-primary-600 transition-colors duration-200 font-medium"
            >
              Contact
            </Link>
            <Link
              to="/privacy"
              className="text-neutral-700 hover:text-primary-600 transition-colors duration-200 font-medium"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="text-neutral-700 hover:text-primary-600 transition-colors duration-200 font-medium"
            >
              Terms
            </Link>
            <button
              onClick={onSubscribeClick}
              className="btn-primary ml-4"
            >
              Subscribe
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="md:hidden p-2 rounded-md text-neutral-700 hover:text-primary-600 hover:bg-neutral-100"
            aria-label="Toggle menu"
          >
            <svg
              className="h-6 w-6"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden pb-4 space-y-4">
            <Link
              to="/contact"
              className="block text-neutral-700 hover:text-primary-600 transition-colors duration-200 font-medium py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </Link>
            <Link
              to="/privacy"
              className="block text-neutral-700 hover:text-primary-600 transition-colors duration-200 font-medium py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="block text-neutral-700 hover:text-primary-600 transition-colors duration-200 font-medium py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              Terms
            </Link>
            <button
              onClick={() => {
                setIsMenuOpen(false);
                onSubscribeClick();
              }}
              className="btn-primary w-full mt-2"
            >
              Subscribe
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
